<template>
	<div
		class="rounded-md flex flex-col gap-3 bg-form-field-bg p-3"
		style="max-height: 20rem; overflow-y: auto;"
		:class="{
			'hidden': !list || (list && list.length < 1)
		}"
	>
		<!--
			The height cap above is an INLINE style, not a Tailwind utility or a
			scoped <style>: this renders inside <suiteweb-navbar>'s shadow root and
			only the root .ce.vue's styles are reliably injected there. Needed
			because `max` is 10 now — ten wrapped questions otherwise run off small
			viewports, and SearchBar animates its wrapper to this element's
			offsetHeight.

			Keep this comment INSIDE the root div. At template root it becomes a
			second root node, making this component a fragment, and SearchBar's
			`this.$refs.dropdown.$el` then resolves to the comment instead of the
			div — offsetHeight undefined, dropdown never opens. Production builds
			strip comments so it only breaks under `yarn serve`.
		-->
		<template v-if="list && list.length > 0">
			<div
				v-for="(item, item_ndx) in list"
				:key="item_ndx"
			>
				<UiLink
					class="cognitive-link"
					:data="item"
				/>
			</div>
		</template>
		<template v-else>
			<div>
				<p>No Previously Asked Questions</p>
			</div>
		</template>
	</div>
</template>

<script>
import store from '@/store'

import UiLink from '@/components/ui/Link'

export default {
	name: 'CognitiveHistoryDropdown',
	components: {
		UiLink
	},
	data() {
		return {
			// Was 3, alongside a "View All History" link. That link pointed at
			// https://suiteweb.atpointofcare.com/#watson/history — a legacy hash
			// route on the old suite app that has no equivalent in the new
			// framework (there is only pages/watson/index.vue). Rather than ship a
			// dead link, it was removed and more history is surfaced inline.
			max: 10
		}
	},
	computed: {
		list() {
			const data = store.getters?.cognitiveHistory
				? this.max
					? store.getters.cognitiveHistory.slice(0, this.max)
					: store.getters.cognitiveHistory
				: []

			return data.map((item) => {
				return {
					'label': item,
					// A button that EMITS, not a link that navigates.
					//
					// This was an <a href> — first to the legacy hash app
					// (https://suiteweb.atpointofcare.com/#watson), then to the real
					// route as <baseUrl>watson?q=…. Both were hard navigations, and a
					// hard navigation into /watson?q=… is broken in the host: the page
					// is pre-rendered by `nuxt generate` with no query string, so
					// query-dependent markup in the first client render diverges from
					// the static HTML and Vue 2 aborts hydration with
					// HierarchyRequestError, stranding the user on "No question asked".
					//
					// Emitting instead re-enters the exact path a typed question takes
					// (form-submit → search-cognitive → the host's router.push), which
					// is client-side and never hydrates. It also removes the
					// double-encoding this needed as a URL: the host encodes now.
					// See documents/2026-08-06-cognitive-search-navbar-changes.md.
					'type': 'button',
					'onClick': () => this.$emit('select', item)
				}
			})
		}
	},
	methods: {
		async getData() {
			await store.dispatch('getCognitiveHistory')
		}
	}
}
</script>